import { useAuth } from '../context/AuthContext';

export type UserRole = 'admin' | 'cashier' | 'kitchen';

export function useRole() {
  const { user } = useAuth();
  const role = (user?.role ?? 'admin') as UserRole;

  return {
    role,
    isAdmin:   role === 'admin',
    isCashier: role === 'cashier',
    isKitchen: role === 'kitchen',
    hasRole: (...roles: UserRole[]) => roles.includes(role),
    canManageUsers:   role === 'admin',
    canAccessReports: role === 'admin' || role === 'cashier',
    canAccessCash:    role === 'admin' || role === 'cashier',
    canAccessKitchen: role === 'admin' || role === 'kitchen',
    canAccessPOS:     role === 'admin' || role === 'cashier',
  };
}
